import React, { useEffect, useState } from "react";
import { Shimmer, TextField, useAsyncError } from "sprint-common-web";

import { PreviewLoadingError } from "../PreviewLoadingError";

interface SubtitlePreviewProps {
    url: string;
    isZip: boolean;
    accessToken?: string;
}

export const SubtitlePreview: React.FC<SubtitlePreviewProps> = ({ url, isZip, accessToken }) => {
    const [fileContent, setFileContent] = useState<string>();
    const throwError = useAsyncError();

    useEffect(() => {
        const isCloudfrontUrl = url.includes("cloudfront.net");
        const headers: Record<string, string> = accessToken && isCloudfrontUrl ? { Authorization: accessToken } : {};
        fetch(url, { method: "GET", headers })
            .then(async (response: Response) => {
                if (response.ok) {
                    const fileSize = await getFileSize(response);

                    if (isZip && fileSize === 0) {
                        throwError(new PreviewLoadingError("Zip file does not have index."));
                    }

                    response.text().then((val: string) => {
                        setFileContent(val);
                    });
                } else {
                    throwError(new PreviewLoadingError());
                }
            })
            .catch(() => {
                throwError(new PreviewLoadingError());
            });
    }, [url]);

    if (!fileContent) {
        return <Shimmer />;
    }

    return <TextField label="Content" multiline={true} rows={20} value={fileContent} />;
};

const getFileSize = async (response: Response) => {
    return response
        .clone()
        .blob()
        .then((blob) => blob.size);
};
